import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import withRouter from "../../withRouter.js";
import {
  clientname,
  currency,
  currentTenant,
  dataaccess,
  financialyearend,
  financialyearstart,
  thousandsdisplay,
  userid,
} from "../../Common/Credentials";
import SalesServices from "../SalesServices";
import { spin } from "../../Common/NewLoader";
import { salesid } from "../../Common/Permissions";
import { NumericFormat } from "react-number-format";
import moment from "moment";
import UsercustomerService from "../../Masters/Usercustomers/UsercustomerService";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { TextField, MenuItem, Tooltip } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

// Import icons
import EditIcon from "../../images/Icons/edit.png";
import ViewIcon from "../../images/Icons/preview.png";
import UpArrow from "../../images/Icons/up-arrow.png";
import '../../NewUI/NewUI.css';
import Breadcrumb from "../../NewUI/NewComponents/Breadcrumb.jsx";
import TabSwitch from "../../NewUI/NewComponents/TabSwitch.jsx";

// TabButton Component (from InvoiceTable)
const TabButton = ({ active, onClick, children }) => (
  <fieldset
    onClick={onClick}
    className={`tab-button ${active ? "active-tab" : "inactive-tab"}`}
    style={{
      cursor: "pointer",
      transition: "all 0.3s ease",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "6px",
      borderRadius: "50px",
      border: "1px solid #e2e8f0",
      padding: "8px 16px",
      fontSize: "0.8rem",
      fontWeight: 500,
    }}
  >
    {children}
    <img
      src={UpArrow}
      alt="Up Arrow"
      style={{
        width: "1.5rem",
        height: "1.5rem",
        padding: "4px",
        transform: active ? "rotate(30deg)" : "rotate(0deg)",
        transition: "transform 0.3s ease",
      }}
    />
  </fieldset>
);

const QuotationTable = ({ navigate }) => {
  const [quotations, setQuotations] = useState([]);
  const [completedQuotations, setCompletedQuotations] = useState([]);
  const [cancelledQuotations, setCancelledQuotations] = useState([]);
  const [usercustomers, setUsercustomers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentView, setCurrentView] = useState('list');
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [activeTab, setActiveTab] = useState('active');
  const [fromdate, setFromdate] = useState(moment().subtract(7, "days"));
  const [todate, setTodate] = useState(moment());
  const [searchTerm, setSearchTerm] = useState("");
  const [showSearch, setShowSearch] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [isNoteExpanded, setIsNoteExpanded] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [isBackHovered, setIsBackHovered] = useState(false);
  const [hoveredRow, setHoveredRow] = useState(null);
  const [hoveredAction, setHoveredAction] = useState(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(20);
  const [filteredSidebarData, setFilteredSidebarData] = useState([]);
  const [hasScrolledToSelected, setHasScrolledToSelected] = useState(false);
  const [sortConfig, setSortConfig] = useState({ key: 'customer', direction: 'asc' });
  const sidebarRef = React.useRef(null);
  const scrollTimeout = React.useRef(null);

  // Sort indicator component
  const SortIndicator = ({ columnKey }) => {
    if (sortConfig.key !== columnKey) {
      return <i className="fa fa-sort UI-sort-icon" />;
    }
    return sortConfig.direction === 'asc'
      ? <i className="fa fa-sort-up UI-sort-icon UI-sort-active" />
      : <i className="fa fa-sort-down UI-sort-icon UI-sort-active" />;
  };

  // Sorting function
  const sortData = (key) => {
    let direction = 'asc';
    if (sortConfig.key === key && sortConfig.direction === 'asc') {
      direction = 'desc';
    }
    setSortConfig({ key, direction });
  };

  const getSortedData = (data) => {
    if (!sortConfig.key) return data;

    return [...data].sort((a, b) => {
      let aValue, bValue;

      switch (sortConfig.key) {
        case 'customer':
          aValue = a.customer || '';
          bValue = b.customer || '';
          break;
        case 'customqtid':
          aValue = a.customqtid || '';
          bValue = b.customqtid || '';
          break;
        case 'agent':
          aValue = a.agent || '';
          bValue = b.agent || '';
          break;
        case 'sotype':
          aValue = a.sotype || '';
          bValue = b.sotype || '';
          break;
        case 'sototalwtax':
          aValue = Number(a.sototalwtax) || 0;
          bValue = Number(b.sototalwtax) || 0;
          break;
        default:
          aValue = a[sortConfig.key] || '';
          bValue = b[sortConfig.key] || '';
      }

      if (aValue < bValue) {
        return sortConfig.direction === 'asc' ? -1 : 1;
      }
      if (aValue > bValue) {
        return sortConfig.direction === 'asc' ? 1 : -1;
      }
      return 0;
    });
  };

  // NEW: Search highlighting methods
  const escapeRegex = (string) => {
    return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  };

  const highlightSearchText = (text, searchTerm) => {
    if (!searchTerm || !searchTerm.trim() || !text) return text;

    // Limit search term length to prevent regex overflow
    const safeSearchTerm = searchTerm.trim().slice(0, 100);

    try {
      const regex = new RegExp(`(${escapeRegex(safeSearchTerm)})`, 'gi');
      const parts = String(text).split(regex);

      return parts.map((part, index) =>
        regex.test(part)
          ? React.createElement('mark', {
            key: index,
            className: "UI-search-highlight"
          }, part)
          : part
      );
    } catch (error) {
      // Fallback: return text without highlighting if regex fails
      console.warn('Regex highlighting failed:', error);
      return text;
    }
  };

  // NEW: Get match counts for each tab
  const getTabMatchCounts = () => {
    if (!searchTerm.trim()) {
      return {
        active: quotations.length,
        completed: completedQuotations.length,
        cancelled: cancelledQuotations.length,
      };
    }

    // Helper function to count matches in a dataset
    const countMatches = (data) => {
      const lowerSearchTerm = searchTerm.toLowerCase();
      return data.filter(quotation =>
        quotation.customer?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.agent?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.customqtid?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.sotype?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.createdbyname?.toLowerCase().includes(lowerSearchTerm) ||
        (quotation.sototalwtax?.toString().includes(searchTerm))
      ).length;
    };

    return {
      active: countMatches(quotations),
      completed: countMatches(completedQuotations),
      cancelled: countMatches(cancelledQuotations),
    };
  };

  // Handle resize
  const handleResize = () => {
    const mobile = window.innerWidth <= 768;
    setIsMobile(mobile);
    if (!mobile) {
      setShowSearch(false);
    }
  };

  useEffect(() => {
    if (window.innerWidth <= 768) {
      setShowSearch(true);
    }
    window.addEventListener('resize', handleResize);

    if (!userid) {
      window.confirm("Your Session is Lost: Please login Back to resume");
      navigate("/");
      return;
    }

    setLoading(true);
    UsercustomerService.GetUserCustomersbyUser(userid).then((res) =>
      setUsercustomers(
        res.data === "" || res.data === undefined
          ? []
          : res.data.customers.split(",")
      )
    );

    refreshQuotations();
    refreshCompletedCancelled(moment().subtract(7, 'days'), moment());

    return () => {
      window.removeEventListener('resize', handleResize);
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }
    };
  }, []);

  useEffect(() => {
    updateFilteredData();
  }, [quotations, completedQuotations, cancelledQuotations, activeTab, searchTerm]);

  useEffect(() => {
    // Auto-scroll in detail view (only once)
    if (currentView === 'detail' && selectedQuotation && sidebarRef.current && !hasScrolledToSelected) {
      if (scrollTimeout.current) {
        clearTimeout(scrollTimeout.current);
      }

      scrollTimeout.current = setTimeout(() => {
        const selectedElement = sidebarRef.current.querySelector(`[data-quotation-id="${selectedQuotation.id}"]`);
        if (selectedElement) {
          selectedElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
          setHasScrolledToSelected(true);
        }
      }, 100);
    }
  }, [currentView, selectedQuotation, hasScrolledToSelected]);

  // Fetch data functions
  const refreshQuotations = () => {
    setLoading(true);
    let datadao = {
      tenantid: currentTenant,
      startdate: financialyearstart,
      enddate: financialyearend,
      userid: userid,
      dataaccess: dataaccess,
    };

    SalesServices.GetActiveQuotations(datadao)
      .then((response) => {
        const filteredData = response.data
          .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
          .filter((e) =>
            usercustomers.length === 0 ? e : usercustomers.includes(e.customer)
          );
        setQuotations(filteredData);
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        if (e.response?.data?.error === "Unauthorized") {
          alert("Your Session is Lost: Please login Back to resume");
          navigate("/");
        }
      });
  };

  const refreshCompletedCancelled = (from, to) => {
    let datadao = {
      tenantid: currentTenant,
      startdate: from,
      enddate: to,
      userid: userid,
      dataaccess: dataaccess,
    };

    SalesServices.GetCompletedQuotations(datadao).then((response) => {
      const filteredData = response.data
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
        .filter((e) =>
          usercustomers.length === 0 ? e : usercustomers.includes(e.customer)
        );
      setCompletedQuotations(filteredData);
    });

    SalesServices.GetClosedQuotations(datadao).then((response) => {
      const filteredData = response.data
        .sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1))
        .filter((e) =>
          usercustomers.length === 0 ? e : usercustomers.includes(e.customer)
        );
      setCancelledQuotations(filteredData);
    });
  };

  const updateFilteredData = () => {
    let data = [];
    switch (activeTab) {
      case 'active':
        data = quotations;
        break;
      case 'completed':
        data = completedQuotations;
        break;
      case 'cancelled':
        data = cancelledQuotations;
        break;
      default:
        data = quotations;
    }

    let filtered;
    if (!searchTerm.trim()) {
      filtered = data;
    } else {
      const lowerSearchTerm = searchTerm.toLowerCase();
      filtered = data.filter(quotation =>
        quotation.customer?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.agent?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.customqtid?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.sotype?.toLowerCase().includes(lowerSearchTerm) ||
        quotation.createdbyname?.toLowerCase().includes(lowerSearchTerm) ||
        (quotation.sototalwtax?.toString().includes(searchTerm))
      );
    }

    setFilteredData(filtered);
    if (currentView === 'detail') {
      setFilteredSidebarData(filtered);
    }
    setCurrentPage(1);
  };

  // Get current page data for pagination (with sorting)
  const getCurrentPageData = () => {
    const sortedData = getSortedData(filteredData);
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return sortedData.slice(indexOfFirstItem, indexOfLastItem);
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  // Handle items per page change
  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(parseInt(e.target.value));
    setCurrentPage(1);
  };

  const handleSearch = (term) => {
    setSearchTerm(term);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
    setCurrentView('list');
    setSelectedQuotation(null);
    setSearchTerm("");
    setShowSearch(false);
    setSortConfig({ key: 'customer', direction: 'asc' });
  };

  const handleFromDateChange = (date) => {
    setFromdate(date);
    if (moment(date).diff(todate, "days") >= 0) {
      setTodate(date);
    }
  };

  const handleToDateChange = (date) => {
    setTodate(date);
  };

  const applyDateFilter = () => {
    refreshCompletedCancelled(fromdate, todate);
  };


  const formatCurrency = (amount, ccamount, invCurrency, convRate, mainCurrency, color, searchTerm) => {
    const numAmount = Number(amount || 0);
    const conversionRate = Number(convRate || 1);

    const mainPrefix = mainCurrency === 'INR' ? '₹ ' : mainCurrency === 'USD' ? '$ ' : mainCurrency + ' ';
    const formattedMain = `${mainPrefix}${numAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    const convertedAmount = ccamount ? ccamount : numAmount * conversionRate;
    const invPrefix = invCurrency === 'INR' ? '₹ ' : invCurrency === 'USD' ? '$ ' : invCurrency + ' ';
    const formattedConverted = `${invPrefix}${convertedAmount.toLocaleString('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;

    if (mainCurrency !== invCurrency && numAmount > 0) {
      return (
        <div style={{ textAlign: 'right', color }}>
          <div>{highlightSearchText(formattedMain, searchTerm)}</div>
          <div style={{ fontSize: '0.72rem', color: '#888' }}>
            {highlightSearchText(formattedConverted, searchTerm)}
          </div>
        </div>
      );
    }

    return (
      <span style={{ color }}>
        {highlightSearchText(formattedMain, searchTerm)}
      </span>
    );
  }

  const exportPDF = () => {
    const curdate = moment().format("DD-MM-YYYY HH:mm:ss");
    const columns = [
      { header: "Quotation ID", dataKey: "customqtid" },
      { header: "Customer", dataKey: "customer" },
      { header: "Agent", dataKey: "agent" },
      { header: "Date", dataKey: "createdAt" },
      { header: "Type", dataKey: "sotype" },
      { header: "Created By", dataKey: "createdbyname" },
      { header: "Total Amount", dataKey: "sototalwtax" },
    ];

    const data = activeTab === 'active' ? quotations :
      activeTab === 'completed' ? completedQuotations :
        cancelledQuotations;

    var doc = new jsPDF("p", "pt", [842, 595]);
    autoTable(doc, {
      theme: "grid",
      startY: 100,
      columnStyles: { 6: { halign: "right" } },
      body: data,
      columns: columns,
      didDrawPage: (data) => {
        doc.setFontSize(16);
        doc.text("Quotations", 40, 50);
        doc.setFontSize(10);
        doc.text(`Generated on: ${curdate}`, 500, 50, { align: "right" });

        const pageCount = doc.internal.getNumberOfPages();
        doc.setFontSize(10);
        doc.text(`Page ${data.pageNumber} of ${pageCount}`, 500, 800, { align: "right" });
      },
    });

    doc.save(`Quotations_${activeTab}_${curdate}.pdf`);
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'active': return { text: 'Active', style: "UI-status-badge-active" };
      case 'completed': return { text: 'Completed', style: "UI-status-badge-completed" };
      case 'cancelled': return { text: 'Cancelled', style: "UI-status-badge-cancelled" };
      default: return { text: status, style: "UI-status-badge-active" };
    }
  };

  const handleQuotationClick = (quotation) => {
    setSelectedQuotation(quotation);
    setCurrentView('detail');
    setHasScrolledToSelected(false);
    setFilteredSidebarData(filteredData);
  };

  const handleBackToList = () => {
    setCurrentView('list');
    setSelectedQuotation(null);
    setHasScrolledToSelected(false);
  };

  const toggleNote = () => {
    setIsNoteExpanded(!isNoteExpanded);
  };

  // Render pagination controls
  const renderPagination = () => {
    if (filteredData.length <= itemsPerPage) return null;

    const totalPages = Math.ceil(filteredData.length / itemsPerPage);

    return (
      <div className={`UI-pagination-container ${isMobile ? 'UI-pagination-container-mobile' : ''}`}>
        <div className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
          Showing {((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, filteredData.length)} of {filteredData.length} quotations
        </div>
        <div className={`UI-pagination-controls ${isMobile ? 'UI-pagination-controls-mobile' : ''}`}>
          <TextField
            select
            value={itemsPerPage}
            onChange={handleItemsPerPageChange}
            variant="outlined"
            size="small"
            className={`UI-page-size-select ${isMobile ? 'UI-page-size-select-mobile' : ''} ${hovered === 'pageSize' ? 'UI-page-size-select-hover' : ''}`}
            onMouseEnter={() => setHovered('pageSize')}
            onMouseLeave={() => setHovered(null)}
          >
            <MenuItem value={5}>5 per page</MenuItem>
            <MenuItem value={10}>10 per page</MenuItem>
            <MenuItem value={20}>20 per page</MenuItem>
            <MenuItem value={50}>50 per page</MenuItem>
          </TextField>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${hovered === 'first' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && setHovered('first')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'First' : 'First'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === 1 ? 'UI-pagination-button-disabled' : ''} ${hovered === 'prev' && !(currentPage === 1) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            onMouseEnter={() => !(currentPage === 1) && setHovered('prev')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Prev' : 'Previous'}
          </button>

          <span className={`UI-pagination-info ${isMobile ? 'UI-pagination-info-mobile' : ''}`}>
            Page {currentPage} of {totalPages}
          </span>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${hovered === 'next' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && setHovered('next')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Next' : 'Next'}
          </button>

          <button
            className={`UI-pagination-button ${isMobile ? 'UI-pagination-button-mobile' : ''} ${currentPage === totalPages ? 'UI-pagination-button-disabled' : ''} ${hovered === 'last' && !(currentPage === totalPages) ? 'UI-pagination-button-hover' : ''}`}
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
            onMouseEnter={() => !(currentPage === totalPages) && setHovered('last')}
            onMouseLeave={() => setHovered(null)}
          >
            {isMobile ? 'Last' : 'Last'}
          </button>
        </div>
      </div>
    );
  };

  const renderTable = () => {
    const currentPageData = getCurrentPageData();

    if (filteredData.length === 0) {
      return (
        <div className={`UI-no-data-message ${isMobile ? 'UI-no-data-message-mobile' : ''}`}>
          {searchTerm ? 'No quotations found matching your search' : 'No quotations available'}
        </div>
      );
    }

    return (
      <>
        <div className={`UI-table-container ${isMobile ? 'UI-table-container-mobile' : ''}`}>
          <table className={`UI-table ${isMobile ? 'UI-table-mobile' : ''}`}>
            <thead className="UI-table-header">
              <tr>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'customer' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('customer')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Customer
                    <SortIndicator columnKey="customer" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'customqtid' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('customqtid')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Quotation Id
                    <SortIndicator columnKey="customqtid" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'agent' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('agent')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Agent
                    <SortIndicator columnKey="agent" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'sotype' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('sotype')}
                  style={{ cursor: 'pointer' }}
                >
                  <div className="UI-th-content">
                    Type
                    <SortIndicator columnKey="sotype" />
                  </div>
                </th>
                <th
                  className={`UI-th ${isMobile ? 'UI-th-mobile' : ''} ${sortConfig.key === 'sototalwtax' ? 'UI-th-sorted' : ''}`}
                  onClick={() => sortData('sototalwtax')}
                  style={{ cursor: 'pointer', textAlign: 'right' }}
                >
                  <div className="UI-th-content" style={{ justifyContent: 'flex-end' }}>
                    Total Amount
                    <SortIndicator columnKey="sototalwtax" />
                  </div>
                </th>
                <th className={`UI-th ${isMobile ? 'UI-th-mobile' : ''}`} style={{ textAlign: 'center' }}>Actions</th>
              </tr>
            </thead>
            <tbody className="mb-2">
              {currentPageData.map((quotation) => (
                <tr
                  key={quotation.id}
                  className={`UI-table-row ${isMobile ? 'UI-table-row-mobile' : ''} ${hoveredRow === quotation.id ? (isMobile ? 'UI-table-row-hovered-quotation-mobile' : 'UI-table-row-hovered') : ''}`}
                  onClick={() => handleQuotationClick(quotation)}
                  onMouseEnter={() => setHoveredRow(quotation.id)}
                  onMouseLeave={() => {
                    setHoveredRow(null);
                    setHoveredAction(null);
                  }}
                >
                  {/* Customer Name Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-customer-name`}
                    style={{
                      color: hoveredRow === quotation.id ? '#4d4d4d' : '',
                      transform: hoveredRow === quotation.id ? 'scale(1.009)' : 'scale(1)',
                      fontWeight: hoveredRow === quotation.id ? 'bold' : 'normal',
                      transition: isMobile
                        ? 'all 0.2s ease'
                        : 'color 0.03s ease, transform 0.03s ease',
                    }}
                  >
                    {(() => {
                      const name = quotation.customer || "";
                      const lastChar = name.slice(-1);
                      const rest = name.slice(0, -1);

                      return (
                        <>
                          <span>{highlightSearchText(rest, searchTerm)}</span>
                          <Tooltip
                            title="View Details"
                            placement="right"
                            arrow
                            slotProps={{
                              popper: {
                                sx: { pointerEvents: 'none' },
                              },
                            }}
                            open={!isMobile && hoveredRow === quotation.id && !hoveredAction}
                          >
                            <span style={{ display: "inline-block" }}>
                              {highlightSearchText(lastChar, searchTerm)}
                            </span>
                          </Tooltip>
                        </>
                      );
                    })()}
                  </td>

                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{
                      color: hoveredRow === quotation.id ? '#5f8f3f' : '',
                    }}
                  >
                    {highlightSearchText(quotation.customqtid, searchTerm)}
                  </td>

                  {/* Agent Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{
                      color: hoveredRow === quotation.id ? '#5f8f3f' : '',
                    }}
                  >
                    {highlightSearchText(quotation.agent || "Direct", searchTerm)}
                  </td>

                  {/* Type Cell */}
                  <td
                    className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}
                    style={{
                      color: hoveredRow === quotation.id ? '#5f8f3f' : '',
                    }}
                  >
                    {highlightSearchText(quotation.sotype, searchTerm)}
                  </td>

                  {/* Total Amount Cell */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''} UI-amount`} style={{
                    color: hoveredRow === quotation.id ? 'red' : '',
                    textAlign: 'right',
                  }}>
                    {formatCurrency(quotation.sototalwtax,
                      quotation.currency !== currency && quotation.ccsototalwtax ? quotation.ccsototalwtax : null,
                      quotation.currency,
                      quotation.curconversionrate,
                      currency,
                      'black',
                      searchTerm)}
                  </td>

                  {/* Actions Cell */}
                  <td className={`UI-td ${isMobile ? 'UI-td-mobile' : ''}`}>
                    <div className="UI-action-buttons">
                      <Link
                        to={{ pathname: "/quotationdetails" }}
                        state={{ id: quotation.id, bvstatus: activeTab === "active" ? 0 : 1 }}
                        className={`UI-quotation-action-button ${isMobile ? 'UI-quotation-action-button-mobile' : ''} UI-quotation-view-button`}
                        style={{ textDecoration: "none" }}
                        onClick={(e) => e.stopPropagation()}
                        onMouseEnter={() => setHoveredAction(`view-${quotation.id}`)}
                        onMouseLeave={() => setHoveredAction(null)}
                      >
                        <Tooltip title="Full Details" arrow slotProps={{
                          popper: {
                            sx: { pointerEvents: 'none' },
                          },
                        }}>
                          <img
                            src={ViewIcon}
                            alt="View"
                            className={hoveredAction === `view-${quotation.id}` ? 'UI-action-icon-hover' : ''}
                            style={{
                              width: isMobile ? 16 : 18,
                              height: isMobile ? 16 : 18,
                              transform: hoveredAction === `view-${quotation.id}` ? "scale(1.15)" : "scale(1)",
                              transition: isMobile ? 'all 0.2s ease' : "transform 0.03s ease, filter 0.03s ease",
                              filter: hoveredAction === `view-${quotation.id}`
                                ? "brightness(0) saturate(100%) invert(16%) sepia(6%) saturate(200%) hue-rotate(180deg) brightness(95%) contrast(85%)"
                                : "none",
                            }}
                          />
                        </Tooltip>
                      </Link>
                      {(salesid === "2" || salesid === "3") && (
                        <Link
                          to={{ pathname: "/newquotation" }}
                          state={{
                            id: quotation.id,
                            pagename: "Edit Quotation",
                            salestype: false,
                          }}
                          className={`UI-quotation-action-button ${isMobile ? 'UI-quotation-action-button-mobile' : ''} UI-quotation-edit-button`}
                          style={{ textDecoration: "none" }}
                          onClick={(e) => e.stopPropagation()}
                          onMouseEnter={() => setHoveredAction(`edit-${quotation.id}`)}
                          onMouseLeave={() => setHoveredAction(null)}
                        >
                          <Tooltip title="Edit Quotation" arrow slotProps={{
                            popper: {
                              sx: { pointerEvents: 'none' },
                            },
                          }}>
                            <img
                              src={EditIcon}
                              alt="Edit"
                              className={hoveredAction === `edit-${quotation.id}` ? 'UI-action-icon-hover' : ''}
                              style={{
                                width: isMobile ? 16 : 18,
                                height: isMobile ? 16 : 18,
                                transform: hoveredAction === `edit-${quotation.id}` ? "scale(1.15)" : "scale(1)",
                                transition: isMobile ? 'all 0.2s ease' : "transform 0.03s ease, filter 0.03s ease",
                                filter: hoveredAction === `edit-${quotation.id}`
                                  ? "brightness(0) saturate(100%) invert(16%) sepia(6%) saturate(200%) hue-rotate(180deg) brightness(95%) contrast(85%)"
                                  : "none",
                              }}
                            />
                          </Tooltip>
                        </Link>
                      )}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {renderPagination()}
      </>
    );
  };

  const renderStatusTabs = () => {
    const matchCounts = getTabMatchCounts();

    const tabs = [
      { key: 'active', label: 'Active', handler: () => handleTabChange("active"), active: activeTab === "active", count: matchCounts.active },
      { key: 'completed', label: 'Completed', handler: () => handleTabChange("completed"), active: activeTab === "completed", count: matchCounts.completed },
      { key: 'cancelled', label: 'Cancelled', handler: () => handleTabChange("cancelled"), active: activeTab === "cancelled", count: matchCounts.cancelled }
    ];

    const options = [
      { value: 'active', label: 'Active', count: matchCounts.active },
      { value: 'completed', label: 'Completed', count: matchCounts.completed },
      { value: 'cancelled', label: 'Cancelled', count: matchCounts.cancelled }
    ];

    return (
      <>
        {/* Status Tabs */}
        <div className="UI-quotation-tabs-container !tw-bg-white !tw-py-2 !tw-border-none">
          {/* {tabs.map((tab) => (
            <div
              key={tab.key}
              className={`UI-quotation-tab ${tab.active ? 'UI-quotation-active-tab' : ''} ${hovered === `${tab.key}-tab` ? 'UI-quotation-tab-hovered' : ''}`}
              onClick={tab.handler}
              onMouseEnter={() => setHovered(`${tab.key}-tab`)}
              onMouseLeave={() => setHovered(null)}
            >
              {tab.label}
              {tab.count > 0 && (
                <span className="UI-match-count">
                  {tab.count}
                </span>
              )}
            </div>
          ))} */}

          <TabSwitch
            value={activeTab}
            onChange={handleTabChange}
            options={options}
          />

          {/* Date Filters for Completed/Cancelled */}
          {(activeTab === 'completed' || activeTab === 'cancelled') && (
            <div className="UI-date-filter-container !tw-bg-white !tw-border-none">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                  <DatePicker
                    label="From Date"
                    value={fromdate}
                    onChange={handleFromDateChange}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        style={{ width: '140px' }}
                      />
                    )}
                  />
                  <span style={{ color: '#64748b', fontSize: '0.8rem' }}>to</span>
                  <DatePicker
                    label="To Date"
                    value={todate}
                    onChange={handleToDateChange}
                    minDate={fromdate}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        size="small"
                        style={{ width: '140px' }}
                      />
                    )}
                  />
                </div>
              </LocalizationProvider>
              <button
                className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${hovered === "apply" ? 'UI-btn-outline-hover' : ''}`}
                onClick={applyDateFilter}
                onMouseEnter={() => setHovered('apply')}
                onMouseLeave={() => setHovered(null)}
              >
                <i className="fa fa-filter" style={{ fontSize: '0.7rem' }} />
                Apply
              </button>
            </div>
          )}
        </div>
      </>
    );
  };

  const renderListView = () => {
    return (
      <>
        {renderTable()}

        {activeTab === 'active' && !isNoteExpanded && (
          <div style={{
            backgroundColor: '#fef2f2',
            border: '1px solid #fee2e2',
            borderRadius: '6px',
            padding: '8px 12px',
            margin: '12px 20px',
            fontSize: '0.8rem',
            color: '#b91c1c',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}>
            <span>
              Note: Quotations will be automatically closed at the end of each financial year
              and will not be available for the next financial year.
            </span>
            <button
              onClick={() => setIsNoteExpanded(true)}
              style={{
                background: 'transparent',
                border: 'none',
                color: '#b91c1c',
                fontWeight: 'bold',
                cursor: 'pointer',
                fontSize: '0.8rem'
              }}
            >
              ✕
            </button>
          </div>
        )}
      </>
    );
  };

  const renderDetailView = () => {
    if (!selectedQuotation) return null;

    return (
      <div className="UI-detail-view">
        {/* Sidebar with quotation list */}
        <div className="UI-sidebar">
          <div className="UI-sidebar-header">
            <button
              className={`UI-back-button ${isBackHovered ? 'UI-back-button-hover' : ''}`}
              onClick={handleBackToList}
              onMouseEnter={() => setIsBackHovered(true)}
              onMouseLeave={() => setIsBackHovered(false)}
            >
              <i className="fa fa-arrow-left" /> Back
            </button>
          </div>

          <div className="UI-sidebar-list" ref={sidebarRef}>
            {filteredSidebarData.map((quotation) => (
              <div
                key={quotation.id}
                data-quotation-id={quotation.id}
                className={`UI-sidebar-item ${selectedQuotation.id === quotation.id ? 'UI-sidebar-item-active' : ''}`}
                onClick={() => setSelectedQuotation(quotation)}
                onMouseEnter={() => setHovered(quotation.id)}
                onMouseLeave={() => setHovered(null)}
              >
                <div className={`UI-sidebar-item-name ${hovered === quotation.id ? 'UI-sidebar-item-name-hover' : ''}`}>
                  {highlightSearchText(quotation.customer, searchTerm)}
                </div>
                <div className={`UI-sidebar-item-code ${hovered === quotation.id ? 'UI-sidebar-item-code-hover' : ''}`}>
                  {highlightSearchText(quotation.customqtid, searchTerm)}
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Detail Content */}
        <div className="UI-detail-content">
          <div className="UI-detail-header">
            <div className="UI-detail-title-wrapper">
              <h2 className="UI-detail-title">{highlightSearchText(selectedQuotation.customer, searchTerm)}</h2>
              <p className="UI-detail-subtitle">
                Quotation ID: {highlightSearchText(selectedQuotation.customqtid, searchTerm)}
              </p>
            </div>

            <div className="UI-detail-actions">
              <Link
                to={{ pathname: "/quotationdetails" }}
                state={{ id: selectedQuotation.id, bvstatus: activeTab === "active" ? 0 : 1 }}
                className={`UI-detail-action-button UI-detail-edit-button ${hovered === "view" ? 'UI-edit-button-hover' : ''}`}
                style={{ textDecoration: "none" }}
                onMouseEnter={() => setHovered("view")}
                onMouseLeave={() => setHovered(null)}
              >
                <Tooltip title="View Full Details" arrow slotProps={{
                  popper: {
                    sx: { pointerEvents: 'none' },
                  },
                }}>
                  <img
                    src={ViewIcon}
                    alt="View"
                    className={`UI-action-icon ${hovered === "view" ? 'UI-action-icon-hover' : ''}`}
                  />
                </Tooltip>
              </Link>

              {(salesid === "2" || salesid === "3") && (
                <Link
                  to={{ pathname: "/newquotation" }}
                  state={{ id: selectedQuotation.id, pagename: "Edit Quotation", salestype: false }}
                  className={`UI-detail-action-button UI-detail-edit-button ${hovered === "edit" ? 'UI-edit-button-hover' : ''}`}
                  style={{ textDecoration: "none" }}
                  onMouseEnter={() => setHovered("edit")}
                  onMouseLeave={() => setHovered(null)}
                >
                  <Tooltip title="Edit Quotation" arrow slotProps={{
                    popper: {
                      sx: { pointerEvents: 'none' },
                    },
                  }}>
                    <img
                      src={EditIcon}
                      alt="Edit"
                      className={`UI-action-icon ${hovered === "edit" ? 'UI-action-icon-hover' : ''}`}
                    />
                  </Tooltip>
                </Link>
              )}
            </div>
          </div>

          <div className="UI-detail-grid">
            {/* Basic Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Basic Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Customer</span>
                <span className={`UI-status-badge ${getStatusBadge(activeTab).style}`}>
                  <span className="UI-detail-value">{highlightSearchText(selectedQuotation.customer, searchTerm)}</span>
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Quotation ID</span>
                <span className="UI-detail-value">{highlightSearchText(selectedQuotation.customqtid, searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Date</span>
                <span className="UI-detail-value">
                  {moment(selectedQuotation.createdAt).format("DD-MM-YYYY HH:MM")}
                </span>
              </div>
            </div>

            {/* Agent Details */}
            {selectedQuotation.agent ? (
              <div className="UI-detail-section">
                <h3 className="UI-section-title">Agent Details</h3>
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Agent ID</span>
                  <span className={`UI-status-badge ${getStatusBadge(activeTab).style}`}>
                    <span className="UI-detail-value">{highlightSearchText(selectedQuotation.agentid, searchTerm)}</span>
                  </span>
                </div>
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Agent</span>
                  <span className="UI-detail-value">{highlightSearchText(selectedQuotation.agent, searchTerm)}</span>
                </div>
                <div className="UI-detail-row">
                  <span className="UI-detail-label">Phone No.</span>
                  <span className="UI-detail-value">{highlightSearchText(selectedQuotation.agentphno, searchTerm)}</span>
                </div>
              </div>
            ) : (
              <div className="UI-detail-section">
                <h3 className="UI-section-title">Agent Details</h3>
                <div className="UI-detail-row">
                  <span className={`UI-status-badge ${getStatusBadge(activeTab).style}`}>
                    <span className="UI-detail-value">Direct</span>
                  </span>
                </div>
              </div>
            )}

            {/* Quotation Details */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Quotation Details</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Status</span>
                <span className={`UI-status-badge ${getStatusBadge(activeTab).style}`}>
                  <span className="UI-detail-value">
                    {getStatusBadge(activeTab).text}
                  </span>
                </span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Type</span>
                <span className="UI-detail-value">{highlightSearchText(selectedQuotation.sotype, searchTerm)}</span>
              </div>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Created By</span>
                <span className="UI-detail-value">{highlightSearchText(selectedQuotation.createdbyname, searchTerm)}</span>
              </div>
            </div>

            {/* Financial Information */}
            <div className="UI-detail-section">
              <h3 className="UI-section-title">Financial Information</h3>
              <div className="UI-detail-row">
                <span className="UI-detail-label">Total Amount</span>
                <span className={`UI-status-badge ${getStatusBadge(activeTab).style}`}>
                  <span className="UI-detail-value">
                    {formatCurrency(selectedQuotation.sototalwtax,
                      selectedQuotation.currency !== currency && selectedQuotation.ccsototalwtax ? selectedQuotation.ccsototalwtax : null,
                      selectedQuotation.currency,
                      selectedQuotation.curconversionrate,
                      currency,
                      'black',
                      searchTerm)}
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div className={`UI-container ${isMobile ? 'UI-container-mobile' : ''}`}>
      <div className="UI-card">
        {/* Header */}
        <div className={`UI-header ${isMobile ? 'UI-header-mobile' : ''}`}>
          <Breadcrumb breadcrumbs={[{ name: "Home", path: "/sales" }, { name: "Quotations", path: null }]} />
          <div className={`UI-header-content ${isMobile ? 'UI-header-content-mobile' : ''}`}>
            <div>
              <h1 className={`UI-title ${isMobile ? 'UI-title-mobile' : ''}`}>
                Quotations
              </h1>
              <p className={`UI-subtitle ${isMobile ? 'UI-subtitle-mobile' : ''}`}>
                {currentView === 'detail' && selectedQuotation
                  ? `ID: ${selectedQuotation.id}`
                  : 'Manage your quotations and proposals'
                }
              </p>
            </div>

            <div className={`UI-header-actions ${isMobile ? 'UI-header-actions-mobile' : ''}`}>
              {/* Mobile Search */}
              {isMobile && (
                <input
                  type="text"
                  placeholder="Search quotations..."
                  value={searchTerm}
                  onChange={(e) => handleSearch(e.target.value)}
                  className="UI-mobile-search-input"
                />
              )}

              <div className={`UI-buttons-row ${isMobile ? 'UI-buttons-row-mobile' : ''}`}>
                {/* Desktop Search Toggle */}
                {!isMobile && (
                  <div
                    className={`UI-search-container ${showSearch ? 'UI-search-container-expanded' : ''} ${hovered === "search" ? 'UI-search-container-hover' : ''}`}
                    onClick={() => {
                      if (!showSearch) setShowSearch(true);
                    }}
                    onMouseEnter={() => setHovered("search")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <i className="fa fa-search UI-search-icon" />
                    {!showSearch && "Search"}
                    {showSearch && (
                      <input
                        type="text"
                        placeholder="Search quotations..."
                        value={searchTerm}
                        onChange={(e) => handleSearch(e.target.value)}
                        className="UI-search-input"
                        autoFocus
                        onClick={(e) => e.stopPropagation()}
                        onBlur={() => {
                          if (searchTerm.trim() === "") {
                            setShowSearch(false);
                          }
                        }}
                      />
                    )}
                  </div>
                )}

                {/* Export button */}
                <button
                  className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-outline ${hovered === "export" ? 'UI-btn-outline-hover' : ''}`}
                  onClick={exportPDF}
                  onMouseEnter={() => setHovered("export")}
                  onMouseLeave={() => setHovered(null)}
                >
                  <i className="fa fa-file-pdf" /> {isMobile ? "Export" : "Export"}
                </button>

                {/* New Quotation button */}
                {(salesid === "2" || salesid === "3") && (
                  <Link
                    to={{ pathname: "/newquotation" }}
                    state={{ id: -1, pagename: "New Quotation", salestype: false }}
                    className={`UI-btn ${isMobile ? 'UI-btn-mobile' : ''} UI-btn-primary ${hovered === "new" ? 'UI-btn-primary-hover' : ''}`}
                    style={{ textDecoration: "none" }}
                    onMouseEnter={() => setHovered("new")}
                    onMouseLeave={() => setHovered(null)}
                  >
                    <i className="fa fa-plus" /> {isMobile ? "New" : "New Quotation"}
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>

        {loading ? (
          <div className="UI-loading-container">
            {spin}
          </div>
        ) : (
          <>
            {/* Always show status tabs */}
            {renderStatusTabs()}

            {/* Switch between list and detail view */}
            {currentView === 'list'
              ? renderListView()   // Show table and note
              : renderDetailView() // Show detail view only
            }
          </>
        )}
      </div>
    </div>
  );
};

export default withRouter(QuotationTable);